(function() {
    const megamenuSubmenu = document.querySelectorAll('.megamenu.js-megamenu .megamenu-submenu');
    const navigationsLink = document.querySelectorAll('.js-main-navigation .navigation-header__link');
    navigationsLink.forEach(link => {
        link.addEventListener('mouseover', () => {
            const imgContainer = document.querySelectorAll('.megamenu-submenu .megamenu-image-packshots');
            const oldImages = document.querySelectorAll('.megamenu-submenu .megamenu-image-customize');
            for (let i = 0; i < imgContainer.length; i++) { 
                oldImages[i].style.display="block";
                imgContainer[i].style.display="none"
             }
        });
    });
    for (const megamenu of megamenuSubmenu) {
        const hasImage = megamenu.querySelectorAll('.megamenu-submenu__col--image');
        if (hasImage.length > 0) {
            const linksSubmenu = megamenu.querySelectorAll('.megamenu-linklist .megamenu-linklist__item .megamenu-linklist__label');
            for (const link of linksSubmenu) {
                if (link.href.includes('/collections/')) {
                    const hrefCollection = link.getAttribute('href');
                    const handleCollection = link.getAttribute('href').split('/').slice(-1).toString();
                    link.addEventListener('mouseover', function () {
                        var packshot = document.querySelectorAll(`.packshot-image[data-collection=${handleCollection}]`);
                        const imgContainer = document.querySelectorAll('.megamenu-submenu.megamenu-submenu--visible .megamenu-image-packshots');
                        const oldImages = document.querySelectorAll('.megamenu-submenu.megamenu-submenu--visible .megamenu-image-customize');
                        for (let i = 0; i < imgContainer.length; i++) {
                            if(packshot.length <= i) {
                                break;
                            }
                            oldImages[i].style.display="none";
                            imgContainer[i].style.display="block";
                            let img = imgContainer[i].querySelector('img')
                            let href = imgContainer[i].querySelector('a')
                            if(!img) {
                                img = document.createElement("img");
                                img.setAttribute("loading", "lazy");
                                img.setAttribute("class", "shop-lazyload img-fluid")
                                href = document.createElement('a');
                                href.appendChild(img);
                                imgContainer[i].querySelector('.megamenu-info-packshots').prepend(href)
                            }
                            const title = packshot[i].querySelector('.packshot-title');
                            const oldPrice = packshot[i].querySelector('.packshot__price-old');
                            const newPrice = packshot[i].querySelector('.packshot__price-new');
                            href.setAttribute('href', '/collections/'+handleCollection);
                            href.setAttribute('href', hrefCollection);
                            img.setAttribute('src', packshot[i].querySelector('.img-src').getAttribute('data-src'));
                            imgContainer[i].querySelector('.megamenu-title-packshots').innerText = title.innerText;
                            if(newPrice) {
                                imgContainer[i].querySelector('.megamenu-price-packshots > .packshot__price-new').innerText = `${Shopify.formatMoney(newPrice.innerText, '{{amount}} €').replace("€", Shopify.moneyFormat.split("{")[0] || Shopify.moneyFormat.split("}}")[1])}`;
                            }
                            if(oldPrice) {
                                imgContainer[i].querySelector('.megamenu-price-packshots > .packshot__price-old').innerText = `${Shopify.formatMoney(oldPrice.innerText, '{{amount}} €').replace("€", Shopify.moneyFormat.split("{")[0] || Shopify.moneyFormat.split("}}")[1])}`;
                            }else{
                                imgContainer[i].querySelector('.megamenu-price-packshots > .packshot__price-old').innerText = '';

                            }
                        }
                    });
                }
            }
        }
    }

    // Mobile menu
    const linkMenuMobile = document.querySelectorAll('.menu-mobile__list .js-menu-next');
    linkMenuMobile.forEach(link => {
        if(link.parentNode.querySelector('.menu-mobile__list--second')) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                subMenu = document.querySelector(`.menu-mobile__list--second[data-name=${link.getAttribute('data-menu-name')}]`);
                if(subMenu.classList.contains('active')) {
                    subMenu.classList.remove('active');
                    link.querySelector('.icon svg').style.transform = 'rotate(90deg)'
                } else {
                    subMenu.classList.add('active');
                    link.querySelector('.icon svg').style.transform = 'rotate(270deg)'
                }
            })
        }
    })
})()